module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAA6ElEQVQoU22QsWrCYBSFz4nSQZ+h9Cm6F7rVydIKXazJUujQRYyTehMnIy4OgktiuxTaUl10E9z7FNJXEIei/y1/wRCkdzvnfh9cLnE0Im8nG25mJLVoimWRyk8WYTZciOTPndN3wrm0vcIsv8z37Upkd+BSQUScLc9eQFxjZ0p/QN6ZQ/FZ0HVVRIytUqERxmOCNd2j3A/chV02OskVc5gqdNJvew+p4IfJANAnEHdRy/vInul34xsoXgEOo7Zbpx8kAqK1V/UGHe/5+Ak214P4PkfGUHStsIaiF4k7+g8+dH6YPELR/AUV81CVIeZYIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/service_mobile/jiantou.png
// module id = FsHg
// module chunks = 1